import { ENDPOINTS } from "@/constants/endpoints"
import { FILTERS } from "@/constants/filters"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenericQuery } from "@/hooks/useGenericQuery"
import type { StudentProject } from "@/types/projectTypes"

export const useProjectsData = () => {
  //✅
  return useGenericQuery<StudentProject[]>({
    keys: QUERY_KEYS.projects.index(),
    apiEndpoint: ENDPOINTS.projects.index(),
    filterName: FILTERS.projects.index(),
    paginated: true,
  })
}
